import { TopLevelCategory } from "@robe/core-types/category";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { BaseApiRequest } from "./baseApiRequest";

export interface GetTopLevelCategoriesOptions {
  ids?: string[];
}

export const getTopLevelCategories = (core: XcoreCore, options?: GetTopLevelCategoriesOptions): BaseApiRequest<TopLevelCategory[]> =>
  core.fetch(`/api/category/toplevel${parseQueryParamsObject(options)}`).then((res) => res.json());
